export default {
    idDonor: (state) => state.error,
}